import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const telephone_receiver_small: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...rest}>
      <path
        fill="none"
        stroke={iconColor}
        d="M7.3091,14.9893 C9.8821,19.4453 13.6441,22.1573
      15.9951,21.3623 C16.0791,21.3463 16.1611,21.3223 16.2371,21.2773 L17.9391,20.2953
      C18.4601,19.9953 18.6031,19.2603 18.2581,18.6623 L16.5021,15.6203 C16.1571,15.0223
      15.4491,14.7803 14.9291,15.0803 L12.9551,16.2193 C12.7571,16.3343 12.4921,16.2773
      12.3231,16.0783 C11.6171,15.2453 10.9431,14.2933 10.3351,13.2413 C9.7281,12.1893
      9.2411,11.1303 8.8721,10.1013 C8.7841,9.8563 8.8681,9.5973 9.0651,9.4843 L11.0391,8.3433
      C11.5601,8.0433 11.7041,7.3083 11.3591,6.7113 L9.6021,3.6693 C9.2571,3.0723 8.5491,2.8283
      8.0291,3.1293 L6.3261,4.1123 C6.2501,4.1563 6.1871,4.2153 6.1321,4.2793 C4.2681,5.9183
      4.7361,10.5313 7.3091,14.9893 Z"
      />
    </svg>
  );
};
